import { Fetch } from 'lib';
import type { PageBuilderCategory } from 'types';

type RequestResponses = {
  bestSellerCategories: PageBuilderCategory[];
};

const getFooterInfo = async () =>
  await Fetch<RequestResponses>({
    url: 'adminPageBuilder/getFooterInfo',
  });

export { getFooterInfo };
